// src/pages/Document/Documents.js

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../utils/axiosConfig';
import './Documents.css';

const Documents = () => {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const { data } = await axios.get('/api/documents');
      setDocuments(data);
    } catch (err) {
      console.error('Error fetching documents:', err);
      setError(t('documents.error_loading'));
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (pdfUrl) => {
    window.open(pdfUrl, '_blank');
  };

  if (loading) {
    return (
      <div className="documents-container">
        <h1>{t('documents.title')}</h1>
        <p>{t('documents.loading')}</p>
      </div>
    );
  }

  return (
    <div className="documents-container">
      <h1>{t('documents.title')}</h1>

      {/* Error Message */}
      {error && <p className="error-message">{error}</p>}

      {/* Documents Grid */}
      {documents.length === 0 ? (
        <p className="no-documents">{t('documents.no_documents')}</p>
      ) : (
        <div className="documents-grid">
          {documents.map(({ _id, name, logoUrl, pdfUrl }) => (
            <div
              key={_id}
              className="document-card"
              onClick={() => handleCardClick(pdfUrl)}
              role="button"
              tabIndex="0"
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleCardClick(pdfUrl);
              }}
              aria-label={`${t('documents.document')}: ${name}`}
            >
              <div className="document-logo">
                <img
                  src={logoUrl}
                  alt={`${name} Logo`}
                  onError={(e) => {
                    e.target.src = '/images/fallback-logo.png';
                  }}
                />
              </div>
              <div className="document-name">
                <h3>{name}</h3>
              </div>
              <div className="document-pdf">
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()} // Prevent card click when clicking link
                  aria-label={`${name} ${t('documents.open_pdf_aria')}`}
                >
                  {t('documents.open_pdf')}
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Documents;
